import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { environment } from '../environments/environment';
import { AuthenticationService } from './access/shared/authentication/authentication.service';
import { pageTitle, subPageTitle } from './shared/page_title';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public router: Router,
    protected $gaService: GoogleAnalyticsService,
    protected authenticationService: AuthenticationService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let path = event.urlAfterRedirects;
        if (path.includes("?")) {
          path = path.split("?")[0];
        }
        path = path.replace("(", "").replace(")", "").replace(":", "/").replace("//", "/");

        let title = null;
        let split = path.split('/');
        if (split.length > 1 && !split.includes("login")) {
          if (split.includes("login")) {
            title = "Login"
          } else if (split.length == 2) {
            title = "Home page"
          } else if (split.includes('basket')) {
            title = 'Panier'
          } else {
            let page = pageTitle[split[2]];
            if (page) {
              title = page;
              if (split.length > 3) {
                split.splice(0, 3);
                split.forEach(subpage => {
                  let value = subPageTitle[subpage]
                  if (value) {
                    title += ' - ' + value;
                  }
                })
                title = title.replace("Détails - ", "")
              }
            }
          }

          if (title && title != "Login") {
            let id = this.authenticationService.currentUser$.getValue().roles.includes('ROLE_ANETT') ? environment.gaIdAnett : environment.gaIdClient;
            this.$gaService.gtag('config', id, { 'page_title': title });
            this.$gaService.gtag('config', environment.gaId, { 'page_title': title });
          }
        }
      }
    })
  }

  ngOnInit() {
    document.querySelector('meta[name="app-version"]')?.setAttribute('content', environment.appVersion);
  }
}
